import { Injectable } from '@angular/core';

/** reCAPTCHA Enterprise site key (public). The script that exposes `grecaptcha` is loaded in index.html. */
export const RECAPTCHA_SITE_KEY = '6Le9rtAmAAAAAAJNpaytF64IHj5rrRtK7iXbcEOe';

interface RecaptchaEnterprise {
  execute(siteKey: string, options: { action: string }): Promise<string>;
  ready(callback: () => void): void;
}

interface GrecaptchaApi {
  enterprise: RecaptchaEnterprise;
}

declare global {
  interface Window {
    grecaptcha?: GrecaptchaApi;
  }
}

/**
 * Generates a reCAPTCHA Enterprise v3 token for the given action.
 *
 * Rejects when the script is unavailable or the challenge fails. Unlike Turnstile this does NOT
 * fail open: the server requires a reCAPTCHA token whenever reCAPTCHA is enabled (it dereferences
 * the token without a null guard), so a caller that requests one must surface the failure.
 */
@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  execute(action: string): Promise<string> {
    return new Promise((resolve: (token: string) => void, reject: (reason?: unknown) => void): void => {
      const grecaptcha: GrecaptchaApi | undefined = window.grecaptcha;
      if (!grecaptcha) {
        reject(new Error('reCAPTCHA is not available.'));
        return;
      }
      grecaptcha.enterprise.ready((): void => {
        grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action }).then(resolve, reject);
      });
    });
  }
}
